module.exports = __webpack_public_path__ + "img/vincent_d.8273d820.png";